import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import Spinner from "../Components/Spinner";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const AcceptInvitation = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get("tk");

    const [status, setStatus] = useState("idle");


    const handleAccept = async () => {
        if (!token) {
            setStatus("error");
            return;
        }

        try {
            setStatus("loading");

            const response = await fetch(
                `${GEN_BACKEND_LINK}/accept_invitation`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ token }),
                }
            );

            const data = await response.json();

            if (!response.ok) {
                if (data.error === "invitation_expired") {
                    setStatus("expired");
                    return;
                }

                throw new Error(data.error || "Something went wrong.");
            }


            if (data.next_step === "login" || data.message === "already_accepted") {
                navigate("/login");
            } else if (data.next_step === "register") {
                navigate("/register");
            }

        } catch (err) {
            setStatus("error");
        }
    };


    if (status === "expired") {
        return (
            <div className="accept_invitation_cont">
                <p className="accept_title fade-in">Invitation expired</p>
                <p className="accept_subtitle fade-in">
                    This invitation link has expired. Please request a new invitation.
                </p>
            </div>
        );
    }

    if (status === "error") {
        return (
            <div className="accept_invitation_cont">
                <p className="accept_title fade-in">Something went wrong...</p>
                <p className="accept_subtitle fade-in">Contact the owner and request a new invitation.</p>
                <p className="fade-in" id="privacy_policy_desc">Need help? Contact <a href="mailto:support@abstracht.com">support@abstracht.com</a></p>

            </div>
        );
    }

    return (
        <div className="accept_invitation_cont">
            <p className="accept_title fade-in">
                You've been invited to join Abstracht
            </p>

            <p className="accept_subtitle fade-in">
                Accept this invitation to gain access to your assigned organizations
                and projects.
            </p>

            <button
                className="accept_btn fade-in"
                onClick={handleAccept}
            >
                {status === "loading" ? (
                    <Spinner loading={true} />
                ) : (
                    "Accept invitation"
                )}
            </button>
        </div>
    );
};

export default AcceptInvitation;